/* eslint-disable eqeqeq */
import { message } from "antd";
import { Dispatch } from "redux";
import { RESULT_CODE } from "../../constant";
import { CartItemDto } from "../../dto/cart/cartItemDto";
import { AdvertiseDto } from "../../dto/vending/AdvertiseDto";
import CartItem from "../../dto/vending/CartItemDto";
import { MachineDto } from "../../dto/vending/MachineDto";
import { MemberVoucherReqDto } from "../../dto/vending/MemberVoucherReqDto";
import { PromotionDto } from "../../dto/vending/PromotionDto";
import { ResPromotionGiftVoucherDto } from "../../dto/vending/ResPromotionGiftVoucherDto";
import { VMProductInfoDto } from "../../dto/vending/VMProductInfoDto";
import { cartService } from "../../service/cart.service";
import { FGetState } from "../app.reducer";
import billType from "../bill/bill.type";
import cartType from "./cart.type";
import { utils } from "../../helpers/util";

/**
 * Update a cart item
 * @param product
 */
const updateCartItem = (
  product: VMProductInfoDto,
  vendingInfo?: MachineDto,
  advertiseList?: Array<AdvertiseDto>,
  promotionCombo?: PromotionDto,
  promotionGiftVoucher?: ResPromotionGiftVoucherDto,
  qtyBuy?: number,
  lstPosition?: Array<any>,
) => {
  return async (dispatch: Dispatch, _getState: FGetState) => {
    product.promotionList = utils.getPromotionByOperation(product);
    dispatch({
      type: cartType.CART.UPDATE_CART_ITEM,
      payload: new CartItem(product, vendingInfo, advertiseList, promotionCombo, promotionGiftVoucher, qtyBuy, lstPosition),
    });
  };
};

/**
 * Update cart cached
 */
const updateWholeCart = (data: CartItem) => {
  return async (dispatch: Dispatch, _getState: FGetState) => {
    dispatch({
      type: cartType.CART.UPDATE_WHOLE_CART,
      payload: data
    });
  };
}

/**
 * Action getMemberInfo
 * @param MemberInfoReqDto 
 */
const getMemberVoucher = (param: MemberVoucherReqDto) => {
  return async (dispatch: Dispatch, getState: FGetState) => {
    dispatch({
      type: cartType.CART.LOADING
    });
    try {
      const req = {
        Data: param
      };
      let res = await cartService.getMemberVoucher(req);
      if (res.resultCode == RESULT_CODE.FAIL) {
        dispatch({
          type: cartType.CART.GET_MEMBER_VOUCHER_FAIL,
        });
        message.error(res.message);
      } else {
        dispatch({
          type: cartType.CART.GET_MEMBER_VOUCHER_SUCCESS,
          payload: res.data,
        });
      }
    } catch (err) {
      dispatch({
        type: cartType.CART.ERROR,
        error: err,
      });
    }
  };
};

/**
 * 
 * @param  
 */
const cleanMyVoucher = () => {
  return async (dispatch: Dispatch, getState: FGetState) => {
    dispatch({
      type: cartType.CART.CLEAR_MEMBER_VOUCHER,
    });
  };
};



/**
 * Action add product to cart
 * @param product
 */
const addProductToCart = (
  product: VMProductInfoDto,
  quantity: number,
) => {
  return async (dispatch: Dispatch, _getState: FGetState) => {
    // product.promotionList = utils.getPromotionByOperation(product);
    dispatch({
      type: cartType.CARTS.ADD_TO_CART,
      payload: new CartItemDto(product, quantity),
    });
  };
};

/**
 * Update a cart item quantity
 * @param product
 */
const updateCartItemQuantity = (cartItemIndex: number, newQuanity: number) => {
  return async (dispatch: Dispatch, _getState: FGetState) => {
    dispatch({
      type: cartType.CARTS.UPDATE_CART_ITEM_QTY,
      payload: {
        cartItemIndex: cartItemIndex,
        newQuanity: newQuanity,
      },
    });
  };
};


/**
 * clean data carts
 * @param 
 */
const cleanDataCarts = () => {
  return async (dispatch: Dispatch, _getState: FGetState) => {
    dispatch({
      type: cartType.CARTS.CLEAR_DATA_CARTS,
    });
    dispatch({
      type: billType.BILL.CLEAN_DATA,
    });
  };
};


export default {
  updateCartItem,
  updateWholeCart,
  getMemberVoucher,
  cleanMyVoucher,
  addProductToCart,
  updateCartItemQuantity,
  cleanDataCarts
} as const;
